<ng-container *transloco="let t">
  <div class="done-container">
    <svg
      width="112"
      height="80"
      viewBox="0 0 112 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.25 79.875L0.875 43.5L6.125 38.25L37.25 69.375L105.875 0.75L111.125 6L37.25 79.875Z"
        fill="#007CAA"
      />
    </svg>

    <h1 class="done-title">
      {{ t("confirmation.eh-mydocuments-step4-title") }}
    </h1>
    <div>
      <p class="done-description" *ngIf="sessionType === 'orders'">
        {{ t("confirmation.eh-mydocuments-step4-info-orders") }}
      </p>
      <p class="done-description" *ngIf="sessionType === 'quotes'">
        {{ t("confirmation.eh-mydocuments-step4-info-quotes") }}
      </p>
    </div>
    <div *ngIf="!isOCIAribaRole">
      <p class="done-description">
        {{ t("confirmation.eh-mydocuments-step4-info-email") }}
      </p>
    </div>
  </div>
  <div class="done-button-container">
    <button
      (click)="navigateBack()"
      class="done-button"
      mat-raised-button
      type="submit"
    >
      {{ t("confirmation.eh-mydocuments-step4-close") }}
    </button>
  </div>
</ng-container>
